module.exports = __webpack_public_path__ + "media/icons/map-icon-radius-active-4067d207.svg";